import React from "react";
import { PropertyEditorDate, PropertyEditorDateInterface } from "../PropertyEditorDate";
import { StoryNode } from "../../StoryBook/StoryData";
import { IDesignValidationProvider, ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";

class DateData implements PropertyEditorDateInterface {
    editObject: { datedata?: Date } = {};
    hint: string = "hint";
    label: string = "DateEditor";
    parentDefaultValue: string | null = null;
    requiredText: string = "required text";
    propertyName: string = "datedata";
}

let args = new DateData();

class DateData2 implements PropertyEditorDateInterface {
    editObject: { datedata?: Date } & IDesignValidationProvider = {
        getDesignValidationIssues(): ValidationIssue[] {
            return [new ValidationIssue("issue", "datedata"), new ValidationIssue("issue 2", "datedata")];
        },
    };
    hint: string = "hint";
    label: string = "DateEditor";
    parentDefaultValue: string | null = null;
    requiredText: string = "required text";
    propertyName: string = "datedata";
}

let args2 = new DateData2();

export const DatePropertyEditor = [
    new StoryNode(
        (logCallback) => {
            return (
                <PropertyEditorDate
                    {...args}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName) as Date;
                        logCallback(d.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Date",
        "Empty",
    ),
    new StoryNode(
        (logCallback) => {
            args.editObject.datedata = new Date(2000, 10, 1);
            return (
                <PropertyEditorDate
                    {...args}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName) as Date;
                        logCallback(d.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Date",
        "Filled",
    ),
    new StoryNode(
        (logCallback) => {
            args.editObject.datedata = new Date(2000, 10, 1);
            return (
                <PropertyEditorDate
                    {...args}
                    error={"error text"}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName) as Date;
                        logCallback(d.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Date",
        "Error",
    ),
    new StoryNode(
        (logCallback) => {
            args.editObject.datedata = new Date(2000, 10, 1);
            return (
                <PropertyEditorDate
                    {...args2}
                    onChange={() => {
                        let d = Reflect.get(args.editObject, args.propertyName) as Date;
                        logCallback(d.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Property Editors",
        "Date",
        "Validation Provider",
    ),
];
